import Vue from 'vue'
import Router from 'vue-router'


import EdaAddonProducts from "./views/vAddonProducts";
import EdaBrandList from "./views/vBrandList";
import EdaEditProfile from "./views/vEditProfile";
import EdaLogin from "./views/vLogin";
import EdaModelList from "./views/vModelList";
import EdaOrder from "./views/vOrder";
import EdaOrderList from "./views/vOrderList";
import VSolutions from "./views/vSolutions";
import EdaSubmitOrder from "./views/vSubmitOrder";
import EdaConfirmUser from "./views/vConfirmUser";
import EdaResetPassword from "./views/vResetPassword";
import EdaNewUser from "./views/vNewUser";
import EdaChooseRetailer from "./views/vChooseRetailer";
import EdaRecoverPassword from "./views/vRecoverPassword";

import vReports from "./views/vReports";

Vue.use(Router)

var cantOrder = [
  "fjordkraft.salto.no",
];

var canOrder = !cantOrder.includes(window.location.hostname);


export default new Router({
  routes: [
    {
      path: '/',
      component: EdaLogin,
      meta: { requiresAuth: false, hideBack: true, hideUser: true }
    },
    {
      path: '/cars',
      component: EdaBrandList,
      meta: { requiresAuth: true, showOrderOverview: true, hideBack: true }
    },
    {
      path: '/cars/:brand/',
      component: EdaModelList,
      props: true,
      meta: { requiresAuth: true, showOrderOverview: true, showOrderOverview: true }
    },
    {
      path: "/solutions",
      component: VSolutions,
      meta: {
        requiresAuth: true,
        showOrderOverview: true
      }
    },
    {
      path: '/orders/new',
      component: EdaSubmitOrder, meta: { requiresAuth: true, showOrderOverview: true }
    },
    {
      path: '/orders/new/accessories',
      component: EdaAddonProducts,
      props: true,
      meta: { requiresAuth: true, showOrderOverview: true }
    },
    {
      path: '/orders/:id',
      component: EdaOrder,
      props: (route) => ({ id: route.params.id, editable: true, showPrices: true }),
      meta: { requiresAuth: true, hideBack: true, showOrderOverview: true, showNewOrder: canOrder }
    },
    {
      path: '/orders/share/:secret',
      component: EdaOrder,
      props: (route) => ({ secret: route.params.secret, editable: false, showPrices: false }),
      meta: { requiresAuth: false, hideBack: true, showOrderOverview: false, showNewOrder: false, hideUser: true }
    },
    {
      path: '/orders/:id/update',
      component: EdaSubmitOrder,
      props: true,
      meta: { requiresAuth: true, hideBack: true, showOrderOverview: true, showNewOrder: canOrder }
    },
    {
      path: '/orders',
      component: EdaOrderList,
      meta: { requiresAuth: true, showNewOrder: canOrder && true, hideBack: true }
    },
    {
      path: '/orders/:search/:sort/:page',
      name: "orders-filtered",
      component: EdaOrderList,
      props: true,
      meta: { requiresAuth: true, showNewOrder: canOrder && true, hideBack: true }
    },

    {
      path: '/user',
      component: EdaEditProfile,
      meta: { requiresAuth: true }
    },
    {
      path: '/user/retailer',
      component: EdaChooseRetailer,
      meta: { hideBack: true, requiresAuth: true, hideUser: true }
    },
    {
      path: '/user/reset/:hash',
      component: EdaResetPassword,
      props: true,
      meta: { hideBack: true, requiresAuth: false, hideUser: true }
    },

    {
      path: '/user/confirm/:hash',
      component: EdaConfirmUser,
      props: true,
      meta: { hideBack: true, requiresAuth: false, hideUser: true }
    },
    {
      path: '/user/new',
      component: EdaNewUser,
      meta: { requiresAuth: false, hideUser: true }
    },
    {
      path: '/user/recover',
      component: EdaRecoverPassword,
      meta: { requiresAuth: false, hideUser: true }
    },
    {
      path: '/reports',
      component: vReports,
      meta: { requiresAuth: true }
    },
  ]
})



